import React, { useContext } from 'react'
import { DepartmentContext } from '#src/context/department'
import { useHistory } from 'react-router-dom'
import { loginLocation } from '#src/services/routing'
import { generateCreateUrlFromCategory } from '#src/services/path'
import { GuestCartConsumer } from '#src/containers/Cart'
import { NavItem } from '../TopLevelNavItem'
import CartIcon from '#src/components/Header/StandardHeader/icons/cart.svg'
import styles from './styles.css'

const LoggedOut: React.FC = () => {
  const { department } = useContext(DepartmentContext)
  const history = useHistory()

  return (
    <ul className={styles.navList}>
      <NavItem to={loginLocation(history.location)} rel="nofollow">
        Sign in
      </NavItem>

      <GuestCartConsumer>
        {({ data }) => (
          <NavItem
            to={{
              ...history.location,
              hash: '#cart'
            }}
            isActive={(_match, location) => location.hash === '#cart'}
          >
            {data && data.order.length > 0 && (
              <div className={styles.badge}>{data.order.length}</div>
            )}
            <CartIcon data-testid="desktop-guest-cart-icon" className={styles.navItemIcon} />
            <span className={styles.navItemLabel}>Cart</span>
          </NavItem>
        )}
      </GuestCartConsumer>
      <NavItem
        to={generateCreateUrlFromCategory({
          maybeCategorySlug: department?.topLevelCategory.slug,
          sourceKey: 'primary-nav-get-started',
          pathIntent: 'register'
        })}
      >
        <span className={styles.getStarted}>Get started</span>
      </NavItem>
    </ul>
  )
}

export default LoggedOut
